module.exports = __webpack_public_path__ + "static/img/normal-temperature-delivery.cdcf97f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/1/normal-temperature-delivery.png
// module id = I5Uj
// module chunks = 1